import {
  FETCH_ALL_PRODUCERS,
} from './../../mutation-types';

export default {
  [FETCH_ALL_PRODUCERS](state, producers) {
    state.all = producers;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/producer/mutations.js